import { render, staticRenderFns } from "./EmployeesAssignment.vue?vue&type=template&id=2b17b2d4&scoped=true&"
import script from "./EmployeesAssignment.vue?vue&type=script&lang=js&"
export * from "./EmployeesAssignment.vue?vue&type=script&lang=js&"
import style0 from "./EmployeesAssignment.vue?vue&type=style&index=0&lang=css&"
import style1 from "./EmployeesAssignment.vue?vue&type=style&index=1&id=2b17b2d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b17b2d4",
  null
  
)

export default component.exports